'use client';

import type { FragmentType } from 'src/gql';
import { unmaskFragment } from 'src/gql';

import { extractTagsFromHouseholdTags, HouseholdTagsDisplay } from '../../shared/household-tags-display';
import { ClientsTagsFragment, HouseholdClientFragment } from '../fragments';

type Props = {
  readonly householdFrag: FragmentType<typeof HouseholdClientFragment> | null;
};

export function ClientsTags({ householdFrag }: Props) {
  // Unmask HouseholdClientFragment first, then unmask ClientsTagsFragment from it
  const household = unmaskFragment(HouseholdClientFragment, householdFrag);
  const clientsTagsData = unmaskFragment(ClientsTagsFragment, household);
  const householdTags = clientsTagsData?.householdTags;

  const tags = extractTagsFromHouseholdTags(householdTags);

  return <HouseholdTagsDisplay tags={tags} containerClassName="flex flex-wrap gap-2 pl-3" dropdownMaxWidth="200px" />;
}
